import { memo } from 'react';

import Link from '~/shared/components/Link/Link';
import { Text } from '~/shared/components/Text/Text';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './searchDialogContent.module.css';

export const QuickLinks = memo(() => {
	const { translate } = useTranslation();
	const { data: frame } = useFrame();
	return (
		<div
			className={styles.quickLinksArea}
			aria-live="polite"
		>
			<Text
				className={styles.listLabel}
				as="h3"
				variant="bodySm"
				id="quick-links"
			>
				{translate('search.quick-links-title')}
			</Text>
			<ol
				className={styles.list}
				aria-labelledby="quick-links"
			>
				{frame.search?.quickLinks?.slice(0, 5).map((link) => (
					<li key={`quick-link-${link.id}`}>
						<Link
							title={link.title}
							href={link.url}
						>
							{link.text}
						</Link>
					</li>
				))}
			</ol>
		</div>
	);
});
